//
// MetadataLayoutBuilder
//
// Based on view info from a layout

import { observer } from 'mobx-react-lite'

import { TypedMetadataField } from '.'

export const MetadataLayoutBuilder = observer(function MetadataLayoutBuilder({
    className,
    component,
    components,
    layout,
    record,
    worksheet,
    active_class,
    visited_gids,
}) {
    const metadatafieldname = component.field

    let metadatafield = active_class
        ? active_class.metadata.get(metadatafieldname)
        : undefined

    if (!metadatafield) {
        metadatafield = worksheet.item
            ? worksheet.item.metadata.get(metadatafieldname)
            : undefined
    }
    if (!metadatafield) {
        return null
    }

    let attributes = { className: 'layout-component' }
    if (className) attributes['className'] += ' ' + className
    if (component.style) attributes['className'] += ' lc-' + component.style
    if (component.gid === worksheet.layoutstore.selectedComponentGid) {
        attributes['className'] += ' cc-selected'
    }
    // attributes["onClick"] = e => onClickElement(e, component, layouttreestore)

    let Field = (
        <TypedMetadataField
            name={metadatafieldname}
            field={metadatafield}
            component={component}
            record={record}
            worksheet={worksheet}
        />
    )
    if (!Field) {
        Field = (
            <div>
                <br />
            </div>
        )
    }

    return <div {...attributes}>{Field}</div>
})
